<template>
  <FormWrapper :action="route('catalog.trainer.update', {company: company.id})" method="PUT">
    <div class="main">
      <div class="title-bar row no-gutters">
        <div class="col-12 mb-4 col-sm-8 mb-lg-2">
          <h1 class="mb-2">Edit Company Bio</h1>
          <a class="btn-back" :href="route('catalog.trainer', {company: company.id})">
            <span class="icon icon-arrow-left"></span>
            <span class="text">Go Back</span>
          </a>
        </div>
      </div>

      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters px-3 pl-lg-4 pr-lg-0 pl-xl-5">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>

            <div class="col-12">
              <HtmlField
                  name="bio"
                  label="Company Bio"
                  :value="company.meta.bio"
              />
            </div>
            <div class="col-12 mt-4">
              <button type="submit" class="btn btn-success">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FormWrapper>
</template>
<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    company: { type: Object }
  },
}
</script>